const approvals = require("../../../../../data/tools-expansion/action/implement-one-spec/input/manual-approvals.json")
const {generatedToolDemoPageDefinitions} = require("./GeneratedToolDemoPageCatalog.js")

const DEV_ONLY_LABEL = "Dev only - manual approve needed"
const approvedSpecIds = new Set(approvals.approvedSpecIds || [])
const approvedToolTypes = new Set(generatedToolDemoPageDefinitions
	.filter(page => approvedSpecIds.has(page.specId))
	.map(page => page.toolType))

function isProductionToolRelease() {
	const channel = process.env.VUE_APP_TOOL_RELEASE_CHANNEL || process.env.QW_TOOL_RELEASE_CHANNEL
	return channel ? channel === "production" : process.env.NODE_ENV === "production"
}

function isToolManuallyApproved(toolType) {
	return approvedToolTypes.has(toolType)
}

function isToolAvailable(toolType) {
	return !isProductionToolRelease() || isToolManuallyApproved(toolType)
}

module.exports = {DEV_ONLY_LABEL, isProductionToolRelease, isToolManuallyApproved, isToolAvailable}
